import { ApiCore } from "./core";
import { apiProvider } from "./core/provider";

const url = "inspections";

const apiInspections = new ApiCore({
  list: false,
  get: true,
  post: false,
  put: false,
  patch: false,
  delete: false,
  url: url,
});

apiInspections.deleteDocument = function(policyNo,documentID) {
  return apiProvider.delete(`/inspection/document/${policyNo}`,documentID);
};

apiInspections.getPlannedInspections = function(inspectorID, date, showInspectionsWithNoAppointments) {
  return apiProvider.get(`inspections/planned?inspectorID=${inspectorID}&date=${date}&noappointment=${showInspectionsWithNoAppointments}`);
};

apiInspections.getOpenInspectionsMap = function(showRecentlyCompleted) {
  return apiProvider.list(`inspections/openmap?recentlycompleted=${showRecentlyCompleted}`);
};


apiInspections.getRoute = function(inspectorID, date) {
  return apiProvider.get(`inspections/route?inspectorID=${inspectorID}&date=${date}`);
};


apiInspections.calculateRoute = function(inspectorID, date, startAddress, endAddress, startLocation, endLocation, desiredStartTime, desiredEndTime, planInspectionsWithNoAppointments, overrideStart) {

  const params = new URLSearchParams(
    {
      inspectorID,
      date,
      startAddress,
      endAddress,
      startLocation: `${startLocation?.lat},${startLocation?.lng}`,
      endLocation: `${endLocation?.lat},${endLocation?.lng}`,
      desiredStartTime,
      desiredEndTime,
      noappointment: planInspectionsWithNoAppointments,
      overrideStart: overrideStart ? 'true' : 'false'
    }
  );

  return apiProvider.get(`inspections/calcroute?${params.toString()}`) ;
};

apiInspections.assignInspectionsFromMap = function(inspectorID, date, inspections) {
  return apiProvider.post(`inspections/assignfrommap`, { inspections, inspectorID, date });
};

apiInspections.unAssignInspectionsFromMap = function(inspections) {
  return apiProvider.post(`inspections/unassignfrommap`, { inspections });
};

apiInspections.cancelAppointment = function(policyNo) {
  return apiProvider.post(`inspections/cancelappointment`, { policyNo });
};

apiInspections.cancelAppointments = function(inspections) {
  return apiProvider.post(`inspections/cancelappointments`, { inspections });
};

apiInspections.createCRCManualInspection = function(formData) {
  return apiProvider.post(`inspections/crc/manual`, formData);
};

apiInspections.checkPolicyExists = function(policyNumber) {
  return apiProvider.get(`inspections/check-policy/${encodeURIComponent(policyNumber)}`);
};

apiInspections.getContactInfo = function(policyNumbers) {
  return apiProvider.post(`inspections/contact-info`, { inspections: policyNumbers });
};

apiInspections.sendBatchText = function(policyNumbers, interiorTemplate, exteriorTemplate) {
  return apiProvider.post(`inspections/send-batch-text`, { inspections: policyNumbers, interiorTemplate, exteriorTemplate });
};

apiInspections.getAllPlannedInspections = function(date) {
  return apiProvider.get(`inspections/planned-all?date=${date}`);
};

apiInspections.createExtensionRequest = function(policyNo, extensionDate, templateName, subject, body) {
  return apiProvider.post(`inspection/${policyNo}/extension-request`, { extensionDate, templateName, subject, body });
};

apiInspections.approveExtensionRequest = function(policyNo, extendedDeadline, notes) {
  return apiProvider.post(`inspection/${policyNo}/extension-approve`, { extendedDeadline, notes });
};

apiInspections.getExtensionTemplates = function() {
  return apiProvider.get(`inspection/extension-templates`);
};

apiInspections.orchidApproveExtension = function(policyNo) {
  return apiProvider.post(`inspection/${policyNo}/extension-orchid-approve`, {});
};

apiInspections.orchidRejectExtension = function(policyNo, reason) {
  return apiProvider.post(`inspection/${policyNo}/extension-orchid-reject`, { reason });
};

apiInspections.getPhotos = function(policyNo) {
  return apiProvider.get(`inspection/${policyNo}/photos`);
};

export { apiInspections };
